module.exports = __webpack_public_path__ + "static/media/fk.1bffbf9f.svg";